import { X } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command'
import { useEffect, useRef, useState } from 'react'

const colors = ['bg-sky-200', 'bg-cyan-200', 'bg-blue-200', 'bg-indigo-200']
const getRandomColor = () => colors[Math.floor(Math.random() * colors.length)]

export const MultiSelectCommand = ({ initialSelected, onSelectedChange, disabled }) => {

    const [open, setOpen] = useState(false)
    const [selected, setSelected] = useState(initialSelected)
    const [inputValue, setInputValue] = useState('')
    const commandRef = useRef(null)

    const initialOptions = [
        // { value: 'frontend', label: 'Frontend', bgColor: 'bg-sky-200' },
        // { value: 'backend', label: 'Backend', bgColor: 'bg-cyan-200' },
        // { value: 'design', label: 'Design', bgColor: 'bg-blue-200' },
        // { value: 'devops', label: 'DevOps', bgColor: 'bg-indigo-200' },
    ]

    const [options, setOptions] = useState(initialOptions)

    const handleSelect = (option) => {
        if (selected.some((item) => item.value === option.value)) {
            setSelected(selected.filter((item) => item.value !== option.value))
        } else {
            setSelected([...selected, option])
        }
    }

    const handleCreate = () => {
        const newOption = {
            value: inputValue.toLowerCase(),
            label: inputValue.charAt(0).toUpperCase() + inputValue.slice(1),
            bgColor: getRandomColor()
        }
        setOptions([...options, newOption])
        setSelected([...selected, newOption])
        setInputValue('')
    }

    const handleInputChange = (value) => {
        setInputValue(value)
    }

    const removeItem = (itemToRemove) => {
        setSelected(selected.filter((item) => item.value !== itemToRemove.value))
    }

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (commandRef.current && !commandRef.current.contains(event.target)) {
                setOpen(false)
            }
        }

        document.addEventListener('mousedown', handleOutsideClick)

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick)
        }
    }, [])

    useEffect(() => {
        if (initialSelected && JSON.stringify(initialSelected) === JSON.stringify(selected)) {
            return
        }
        onSelectedChange(selected)
    }, [selected])

    return (
        <div className="flex gap-1 items-center flex-wrap">
            {/* Chosen options */}
            <div className="flex flex-wrap gap-1">
                {
                    selected.map((item) => {
                        return (
                            <div key={item.value}>
                                <Badge className={`gap-1 pr-0.5 text-xsm ${item.bgColor} font-light hover:bg-accent`}>
                                    {item.label}
                                    <button
                                        className="ml-1 rounded-full p-0.5 hover:bg-secondary-foreground/20"
                                        onClick={() => removeItem(item)}
                                    >
                                        <X className="h-3 w-3" />
                                    </button>
                                </Badge>
                            </div>
                        )
                    })
                }
                {/* Command component */}
                <div className="relative" ref={commandRef}>
                    <Command className="w-full border-0" shouldFilter={false}>
                        <CommandInput
                            disabled={disabled}
                            wrapperClassName="border-none"
                            hideSearchIcon
                            className="w-24 text-xsm bg-transparent shadow-none px-0 transition-colors font-light focus:ring-0 focus-visible:border-0 focus-visible:ring-0 focus:border-0 cursor-pointer border-none"
                            placeholder="..."
                            value={inputValue}
                            onValueChange={handleInputChange}
                            onFocus={() => setOpen(true)}
                        />

                        {open && (
                            <div className="absolute left-0 top-full z-10 w-full rounded-lg border bg-popover shadow-md">
                                <CommandList>
                                    <CommandEmpty className="p-2 text-center text-xsm">Type to create new</CommandEmpty>
                                    <CommandGroup>
                                        {options
                                            .filter((option) => !selected.some((item) => item.value === option.value))
                                            .filter((option) => option.label.toLowerCase().includes(inputValue.toLowerCase()))
                                            .map((option) => {
                                                return (
                                                    <CommandItem
                                                        key={option.value}
                                                        className="text-xsm"
                                                        onSelect={() => {
                                                            handleSelect(option)
                                                            setOpen(false)
                                                        }}
                                                    >
                                                        {option.label}
                                                    </CommandItem>
                                                )
                                            })}
                                        {inputValue && !options.some((option) =>
                                            option.label.toLowerCase() === inputValue.toLowerCase()
                                        ) && (
                                                <CommandItem
                                                    onSelect={handleCreate}
                                                    className="text-muted-foreground text-xsm"
                                                >
                                                    Create "{inputValue}"
                                                </CommandItem>
                                            )}
                                    </CommandGroup>
                                </CommandList>
                            </div>
                        )}

                    </Command>
                </div>
            </div>



        </div>
    )
}

